import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import AdminPortal from './admin/AdminPortal';
import reportWebVitals from './reportWebVitals';

function RootRouter() {
  const checkIsAdmin = () => {
    if (typeof window === 'undefined') return false;
    const path = window.location.pathname.toLowerCase();
    const hash = window.location.hash.toLowerCase();
    return path.startsWith('/admin') || hash.startsWith('#/admin');
  };

  const [isAdmin, setIsAdmin] = useState(checkIsAdmin);

  useEffect(() => {
    const onLocationChange = () => {
      setIsAdmin(checkIsAdmin());
    };

    window.addEventListener('popstate', onLocationChange);
    window.addEventListener('hashchange', onLocationChange);
    return () => {
      window.removeEventListener('popstate', onLocationChange);
      window.removeEventListener('hashchange', onLocationChange);
    };
  }, []);

  const navigateToAdmin = () => {
    window.history.pushState({}, '', '/admin');
    setIsAdmin(true);
  };

  const navigateToChat = () => {
    window.history.pushState({}, '', '/');
    setIsAdmin(false);
  };

  if (isAdmin) {
    return <AdminPortal onReturnToChat={navigateToChat} />;
  }

  return <App onOpenAdmin={navigateToAdmin} />;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RootRouter />
  </React.StrictMode>
);

reportWebVitals();
